module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'level-1': _vm.grupo && !_vm.registro, 'level-2': _vm.registro
    },
    attrs: {
      "id": "inspecao"
    }
  }, [_c('div', {
    staticClass: "float-box-view-level-0"
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "col-md-12 float-box-title-extras"
  }, [_c('hr'), _c('ul', {
    staticClass: "nav justify-content-center nav-icons row"
  }, [_c('li', {
    staticClass: "nav-item col-4"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'PONTO'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('PONTO')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-crosshairs-gps"
  }), _c('small', [_vm._v("Ponto")])])]), _c('li', {
    staticClass: "nav-item col-4"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'POLIGONO'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('POLIGONO')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-vector-square"
  }), _c('small', [_vm._v("Área")])])]), _c('li', {
    staticClass: "nav-item col-4"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'SHAPE'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('SHAPE')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-upload"
  }), _c('small', [_vm._v("Shape")])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'PONTO'),
      expression: "tela === 'PONTO'"
    }]
  }, [_c('inspecao-geometria', {
    ref: "PONTO",
    staticClass: "ferramenta-inspecao",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.PONTO,
      "maxAreaHA": _vm.maxAreaHA
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'POLIGONO'),
      expression: "tela === 'POLIGONO'"
    }]
  }, [_c('inspecao-geometria', {
    ref: "POLIGONO",
    staticClass: "ferramenta-inspecao",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.POLIGONO,
      "maxAreaHA": _vm.maxAreaHA
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'SHAPE'),
      expression: "tela === 'SHAPE'"
    }]
  }, [_c('inspecao-shape', {
    ref: "SHAPE",
    staticClass: "ferramenta-inspecao",
    attrs: {
      "maxAreaHA": _vm.maxAreaHA
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.inspecionar
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v(" Inspecionar")]), _c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limpar
    }
  }, [_c('i', {
    staticClass: "mdi mdi-eraser"
  }), _vm._v(" Limpar")])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('alert', {
    attrs: {
      "msg": _vm.mensagemErro || '',
      "visible": _vm.showAlert,
      "type": "error"
    }
  })], 1), _c('div', {
    staticClass: "float-box-content"
  }, [(_vm.pesquisaEfetuada) ? _c('listagem-grupos-registros', {
    ref: "listagemGruposRegistros",
    attrs: {
      "grupos": _vm.gruposInformacao
    },
    on: {
      "exibirGrupo": _vm.exibirGrupo
    }
  }) : _vm._e(), (!_vm.pesquisaEfetuada && (!_vm.camadasAtivas || !_vm.camadasAtivas.length)) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhuma camada ativa"
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "float-box-view-level-1"
  }, [(_vm.grupo) ? _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left action-icon",
    on: {
      "click": function($event) {
        _vm.ocultarGrupo()
      }
    }
  }), _c('span', {
    attrs: {
      "title": _vm.grupo.camada.nome
    }
  }, [_vm._v(_vm._s(_vm.grupo.camada.nome))])])]) : _vm._e(), _c('div', {
    staticClass: "col-12 float-box-content-menu float-box-content-menu-border d-flex flex-row-reverse"
  }, [_c('div', {
    staticClass: "action-link",
    on: {
      "click": function($event) {
        _vm.exportarCSV()
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-download"
  }), _vm._v(" Exportar CSV")])]), _c('div', {
    staticClass: "float-box-content"
  }, [(_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens) ? _c('listagem-registros', {
    ref: "listagemRegistros",
    staticClass: "no-first-border",
    attrs: {
      "registros": _vm.paginacaoRegistros.itens,
      "showMarkers": true
    },
    on: {
      "exibirRegistro": _vm.exibirRegistro
    }
  }) : _vm._e()], 1), (_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens && _vm.paginacaoRegistros.itens.length > 0) ? _c('div', {
    staticClass: "float-box-footer"
  }, [_c('paginacao', {
    ref: "paginacaoRegistros",
    attrs: {
      "total": _vm.paginacaoRegistros.totalItens,
      "page-size": _vm.paginacaoRegistros.itensPorPagina,
      "onChange": _vm.alterarPaginaRegistros,
      "options": _vm.paginationOptions
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "float-box-view-level-2"
  }, [(_vm.registro) ? _c('visualizacao-registro-camada', {
    attrs: {
      "registro": _vm.registro,
      "showReturnButton": true
    },
    on: {
      "close": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "mdi mdi-information-outline"
  }), _vm._v("Inspeção")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b993db40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inspecao/Inspecao.vue
// module id = 489
// module chunks = 1